export default "__VITE_ASSET__DqMyPKV$__"